<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div>
    <div class="header-wrapper">
      <h1>Lista podmiotów</h1>
      <button
        nz-button
        nzType="primary"
        [nzSize]="'default'"
        (click)="createServiceProviderClick()"
      >
        <nz-icon nzType="plus-circle" nzTheme="outline" />
        Dodaj podmiot
      </button>
    </div>

    <div nz-flex [nzGap]="'small'" [nzVertical]="false">
      <button nz-button nz-dropdown [nzDropdownMenu]="typeMenu">
        {{ currentTypeLabel() }}
        <nz-icon nzType="down" />
      </button>
      <nz-dropdown-menu #typeMenu="nzDropdownMenu">
        <ul nz-menu>
          @for (opt of typeOptions; track opt.value) {
            <li nz-menu-item (click)="setType(opt.value)">{{ opt.label }}</li>
          }
        </ul>
      </nz-dropdown-menu>

      <input
        nz-input
        placeholder="Szukaj..."
        [ngModel]="filters().query"
        (ngModelChange)="queryChange($event)"
        style="max-width: 360px"
      />
    </div>
  </div>

  <nz-table
    #basicTable
    class="service-providers-table"
    [nzData]="searchResult()?.results!"
    [nzBordered]="true"
    [nzLoading]="loading()"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzTotal]="total"
    [nzFrontPagination]="false"
    (nzQueryParams)="onQueryParamsChange($event)"
    nzTableLayout="fixed"
  >
    <thead>
      <tr>
        <th nzColumnKey="id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
        <th nzColumnKey="base.type" [nzSortFn]="true">Typ</th>
        <th nzColumnKey="name" [nzSortFn]="true">Nazwa</th>
        <th nzColumnKey="code" [nzSortFn]="true">Kod</th>
        <th nzColumnKey="regon" [nzSortFn]="true">REGON</th>
        <th nzColumnKey="taxId" [nzSortFn]="true">NIP</th>
        <th nzColumnKey="nhfBranchCode" [nzSortFn]="true">Oddz. NFZ</th>
        <th nzColumnKey="place" [nzSortFn]="true">Miejscowość</th>
        <th nzColumnKey="phone" [nzSortFn]="true">Telefon</th>
        <th nzColumnKey="isHidden" [nzSortFn]="true" class="mhs-center">Widoczność</th>
        <th class="mhs-table-action-header">Akcja</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.id }}</td>
        <td>
          @if (data.type === 'Nhf') {
            <nz-tag nzColor="blue">NFZ</nz-tag>
          } @else if (data.type === 'Private') {
            <nz-tag nzColor="green">Prywatny</nz-tag>
          } @else {
            <nz-tag>{{ data.type }}</nz-tag>
          }
        </td>
        <td>{{ data.name }}</td>
        <td>{{ data.code }}</td>
        <td>{{ data.regon }}</td>
        <td>{{ data.taxId }}</td>
        <td>
          {{ nfzBranchCodes.find((branch) => branch.code === data.nhfBranchCode)?.name ?? 'Brak' }}
        </td>
        <td>{{ data.place }}</td>
        <td>{{ data.phone }}</td>

        <td>
          <div
            class="mhs-boolean-icon"
            [attr.aria-label]="data.isHidden ? 'Ukryty' : 'Widoczny'"
            [title]="data.isHidden ? 'Ukryty' : 'Widoczny'"
          >
            <nz-icon [nzType]="data.isHidden ? 'close' : 'check'" />
          </div>
        </td>
        <td class="mhs-table-actions-cell">
          <div class="mhs-table-actions" nz-flex [nzGap]="'small'" [nzVertical]="false">
            <button nz-button nzType="primary" nzShape="circle" (click)="detailsClick(data.id!)">
              <nz-icon nzType="search" />
            </button>
            <a
              nz-dropdown
              [nzDropdownMenu]="userActionsMenu"
              nz-button
              nzType="default"
              nzShape="circle"
            >
              <nz-icon nzType="menu-fold" nzTheme="outline" />
            </a>
            <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="editServiceProviderClick(data.id!)">Edytuj</li>
                @if (data.isHidden) {
                  <li nz-menu-item (click)="unhideServiceProviderClick(data.id!)">Odkryj</li>
                } @else {
                  <li nz-menu-item (click)="hideServiceProviderClick(data.id!)">Ukryj</li>
                }
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
